import React from 'react';

function MapSVG({ data, d, stateName, updateTooltipText }) {
  if (data) {
    const bluePercentage = data.democrat;
    const redPercentage = data.republican;
    const total = data.total;
    const fillColor = bluePercentage > redPercentage ? '#0A3161' : '#B31942';
    const tooltipText = (
      <>
        <b style={{ 'color': 'yellow' }}>{stateName} </b> 
        <span className='italics'>Democrats: <span style={{ 'color': 'yellow' }}>{bluePercentage}%</span> Republicans: <span style={{ 'color': 'yellow' }}>{redPercentage}% </span>
        Total Votes: <span style={{ 'color': 'yellow' }}>{data.total.toLocaleString()}</span></span>
      </>
    );
    const showInfo = () => {
      updateTooltipText(tooltipText);
    };
    return (
      <>
        <path
          stroke="#fff"
          fill={fillColor}
          strokeWidth="0.3"
          d={d}
          onMouseOver={showInfo}
        />
   
      </>
    );
  } else {
    console.log("Data is undefined or null.");
    return null;
  }
}

export default MapSVG;
